import React from "react";
import PropTypes from "prop-types";

/**
 * Visor de parcelas
 */
export default class Login extends React.Component {
  onSearch(data) {}
  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    return (
      <React.Fragment>
        <div class="columns">
          <div class="column" />
          <div class="column">
            <div className="card">
              <div className="card-content">
                <div className="field">
                  <label className="label">Usuario</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      placeholder="usuario@email.com.py"
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">Contraseña</label>
                  <div className="control">
                    <input
                      className="input"
                      type="password"
                      placeholder="Ingrese su contraseña"
                    />
                  </div>
                </div>

                <div className="control">
                  <button className="button is-primary">Ingresar</button>
                </div>
              </div>
            </div>
          </div>

          <div class="column" />
        </div>
      </React.Fragment>
    );
  }
}
